import { render, staticRenderFns } from "./ReceiveMethods.vue?vue&type=template&id=b1b2e9d4&scoped=true&"
import script from "./ReceiveMethods.vue?vue&type=script&lang=js&"
export * from "./ReceiveMethods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b2e9d4",
  null
  
)

export default component.exports